import { typographyTokens } from '../../../../theme/typographyTokens';
import React, { useEffect, useState } from 'react';
import {
  Fade,
  Paper,
  ClickAwayListener,
  Popper,
  Box,
  Button,
  TextField,
  MenuList,
  MenuItem,
  InputAdornment,
  Divider,
  Chip,
  Typography,
  ThemeProvider,
  createTheme,
  useTheme
} from '@mui/material';
import { styled } from '@mui/system';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import CheckIcon from '@mui/icons-material/Check';
import UserSearchBar from '../../../TaskOverview/AutoComplete';
import { useGetDepartmentsQuery } from '../../../../../frontend/services/departmentSlice/departmentSlice';
import { useGetTaskTemplatesQuery } from '../../../../../frontend/services/tasksSlice/tasksSlice';
import { useGetKnockoutScreenTemplateQuery } from '../../../../../frontend/services/knockoutSlice';
import { KnockoutFollowupExtended } from '../../../../../shared/types/Knockout';
import {useGetUserSettingTasksQuery} from '../../../../../frontend/services/usersSlice';

const FollowupTypeDropDown = ({
  type,
  followup,
  onChange,
  onUserChange,
}: {
  type: string;
  followup: KnockoutFollowupExtended | null;
  onChange: (val: number) => void;
  onUserChange: (userID: string) => void;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selected, setSelected] = useState<string | null>(null);
  const [search, setSearch] = useState<string>('');
  const [open, setOpen] = useState<boolean>(false);
  const [adAppRole, setAdAppRole] = useState<string>('');

  const departments = useGetDepartmentsQuery();
  const tasks = useGetTaskTemplatesQuery();
  const knockoutScreens = useGetKnockoutScreenTemplateQuery();
  const theme = useTheme();

  useEffect(() => {
    if (type === 'Task') setSelected(followup?.followupTask?.name || null);
    if (type === 'KnockoutScreen')
      setSelected(followup?.followupScreen?.name || null);
  }, [followup, type]);

  const data =
    type === 'DefaultStakeholder'
      ? departments?.data
        ? departments.data
        : []
      : type === 'Task'
      ? tasks?.data
        ? tasks.data
        : []
      : knockoutScreens?.data
      ? knockoutScreens.data
      : [];
  const handleMenuOption = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const renderDropDownMenu = () => {
    return data
      .map((e) => ({
        name: e.name,
        id: e.id,
        role: 'adAppRole' in e ? e.adAppRole : '',
      }))
      .filter((f: any) => f.name.toLowerCase().includes(search.toLowerCase()));
  };

  const renderOption = (value: any) => {
    if (selected === value.name) {
      return (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          {value.name}
          <CheckIcon />
        </Box>
      );
    }
    return value.name;
  };

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Button
          variant="outlined"
          id="demo-followup-type-menu-button"
          aria-describedby="follow-up"
          aria-controls={open ? 'followup-type-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleMenuOption}
          sx={{
            color: theme.palette.mode === 'dark' ? theme.palette.white.main : selected === null ? '#7E8083' : '#222222',
            textTransform: 'none',
            borderColor: '#7E8083',
          }}
        >
          {selected === null ? 'Choose an option from the dropdown' : selected}
          &nbsp;&nbsp;
          <i className="fa-sharp fa-solid fa-chevron-down" />
        </Button>
        <Popper
          id="follow-up"
          open={open}
          anchorEl={anchorEl}
          transition
          disablePortal
          sx={{ zIndex: 1 }}
        >
          {({ TransitionProps, placement }) => (
            <Fade
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === 'bottom' ? 'center top' : 'center bottom',
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={() => setOpen(false)}>
                  <MenuList autoFocusItem={open}>
                    <MenuItem disableTouchRipple={true}>
                      <TextField
                        placeholder={`Search ${
                          type === 'DefaultStakeholder'
                            ? 'Departments'
                            : type === 'Task'
                            ? 'Tasks'
                            : 'Knockout Screens'
                        }…`}
                        size="small"
                        sx={{ width: '100%' }}
                        onChange={(e) => setSearch(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </MenuItem>
                    <Divider />
                    <Box sx={{ maxHeight: '300px', overflow: 'auto' }}>
                      {renderDropDownMenu().map((item: any, index: number) => {
                        return (
                          <Box key={index}>
                            <MenuItem
                              onClick={() => {
                                setSelected(item.name);
                                onChange(item.id);
                                setAnchorEl(null);
                                if (type === 'DefaultStakeholder')
                                  setAdAppRole(item.adAppRole);
                                setOpen(false);
                              }}
                            >
                              {renderOption(item)}
                            </MenuItem>
                            <Divider />
                          </Box>
                        );
                      })}
                    </Box>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Fade>
          )}
        </Popper>
      </Box>
      {type === 'DefaultStakeholder' && (
        <>
          <Box sx={{ color: theme.palette.mode === 'dark' ? theme.palette.white.main : '#222222', width: '216px' }}>
            Default Stakeholder
          </Box>
          <UserSearch
            adAppRole={adAppRole}
            disabled={adAppRole === ''}
            onChange={onUserChange}
          />
        </>
      )}
    </Box>
  );
};

const theme = createTheme({
});
interface StyledChipProps {
  onDelete: (tag: string) => void;
  getTaskSetting?: any;
}

const StyledChip = styled(Chip)<StyledChipProps>(({ theme, getTaskSetting }) => ({
  margin: theme.spacing(0.5),
  transition: 'all 0.3s',
  '&.MuiButtonBase-root.MuiChip-root': {
    // color: getTaskSetting?.themeMode === 'dark' ? theme.palette.background.paper : "gray.main",
  },
  
}));

export const UserSearch = ({
  adAppRole,
  disabled,
  onChange,
  existDefault,
  user,
  multiple,
  multipleUsers,
  showUser,
  setShowUser,
  setWeightageList,
  weightageListVal,
  showWeightageInput,
  showRecipients
}: {
  adAppRole: string;
  disabled: boolean;
  onChange: any;
  existDefault?: boolean;
  user?: string;
  multiple?: boolean;
  multipleUsers?: any;
  showUser?: any;
  setShowUser?: any;
  setWeightageList?: any;
  weightageListVal?: any;
  showWeightageInput?: boolean;
  showRecipients?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState('');
  const [multiSelectedUsers, setMultiSelectedUsers] = useState<{ id: string, displayName: string }[]>([]);
  const theme = useTheme();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [roundRobinWeightage, setRoundRobinWeightage ] = useState<{ id: string, displayName: string }[]>([])
  useEffect(() => {
    const filteredUsers = Array.isArray(multipleUsers) ? multipleUsers.filter(u => u !== undefined) : [];
    if (filteredUsers?.length > 0) {
      const initialUsers = multipleUsers?.map((u: any) => ({ id: u?.id, displayName: u?.displayName })).filter((user: any) => user.id !== undefined && user.displayName !== undefined);
      if(showUser && initialUsers){
      setMultiSelectedUsers(initialUsers);
      } else if(initialUsers?.length === 0){
      setMultiSelectedUsers([]);
      }
    } else if(!showUser){
      setMultiSelectedUsers(multiSelectedUsers);
    }
    if(!showUser && showRecipients){
      setMultiSelectedUsers([]);
    } 
    // setShowUser(!showUser)
  }, [multipleUsers, multiple, user]);

  const textFieldSx = {
    color: "#222222",
    "& > p": {
      margin: "5px 0px",
      color: "#646669",
      fontSize: typographyTokens.fontSizes.xs,
    },
  };

  const { data: getTaskSetting } = useGetUserSettingTasksQuery();

  const handleDeleteTag = (tagToDelete: string) => {
    const updatedUsers = multiSelectedUsers?.filter(user => user.id !== tagToDelete);
    setMultiSelectedUsers(updatedUsers);
    setShowUser(false)
    onChange(updatedUsers.map(usr => usr.id));
  };

  useEffect(()=>{
    setRoundRobinWeightage(JSON.parse(JSON.stringify(multiSelectedUsers)))
  },[multipleUsers, multiple, multiSelectedUsers])

  const handleWeightageChange = (e: any, id: string) =>{
    const value = e.target.value
    setWeightageList((prev: any)=> prev.some((item: any) => item?.id ===id) ? prev. map((item: any) => item?.id === id ? {...item, value}: item ): [...prev, {id, value}]);
  }
 
  const handleUserChange = (user: any) => {
    if (multiple) {
      if (!multiSelectedUsers.some(u => u.id === user.id)) {
        const newUser = { id: user.id, displayName: user.displayName || '' };
        const updatedUsers = [...multiSelectedUsers, newUser];
        setMultiSelectedUsers(updatedUsers);
        setShowUser(false);
        onChange(updatedUsers?.map(u => u.id)); 
      }
    } else {
      onChange(user.id);
      setSelected(user.displayName || '');
      setOpen(false);
    }
  
  };
  useEffect(() => {
    setSelected(user || '');
  }, [user]);
  return (
    <Box>
      {multiple ? (
        <ThemeProvider theme={theme}>
        <Box
          role="region"
          aria-label="Tag Input System"
          onClick={(e) => {
            setOpen(!open);
            setAnchorEl(e.currentTarget);
          }}
          sx={{ border: '1px solid', padding: '5px', cursor: 'pointer',  borderRadius: '4px', minHeight:'40px'}}
        >
            {multiSelectedUsers?.map(({ id, displayName }) => (
              <StyledChip
              key={id}
              label={displayName}
              onDelete={() => handleDeleteTag(id)}
              deleteIcon={<CloseIcon />}
              getTaskSetting={getTaskSetting}
              />
            ))}
        </Box>
        {showWeightageInput && (
        <>
        <Box sx={{  mt:'30px',mb:'5px' }}>
                         Weightage list (Click in box to add weightage number)
                     </Box>
        {roundRobinWeightage?.map(({ id, displayName }) => (
        <Box
          key={id}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: "10px",
            padding: "10px",
            border: "1px solid #e0e0e0",
            borderRadius: "4px",
            // backgroundColor: "#f9f9f9",
          }}
        >
          <span>{displayName}</span>
          <TextField
            sx={textFieldSx}
            size="small"
            id={`weightage-${id}`}
            name="weightage"
            type="number"
            value={
              weightageListVal && Array.isArray(weightageListVal)
                ? weightageListVal.find((item: any) => item.id === id)?.value ?? ''
                : ''
            }
            onChange={(e: any) => handleWeightageChange(e, id)}
            InputProps={{
              inputProps: { min: 0 }
            }}
          />
        </Box>
          ))}
        </>
        )}
      </ThemeProvider>
      ): (
      <Button
        variant="outlined"
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        disabled={disabled}
        onClick={(e) => {
          setOpen(!open);
          setAnchorEl(e.currentTarget);
        }}
        sx={{
          color: selected === '' ? '#7E8083' : theme.palette.mode === 'dark' ? theme.palette.white.main : '#222222',
          textTransform: 'none',
          borderColor: '#7E8083',
          zIndex: '0',
        }}
      >
        {selected === ''
          ? existDefault
            ? 'Default'
            : 'Choose a user from the dropdown'
          : selected}
        &nbsp;&nbsp;
        <i className="fa-sharp fa-solid fa-chevron-down" />
      </Button>
      )}
      <UserSearchBar
        show={open}
        type="knockoutScreen"
        adAppRoleName={adAppRole}
        anchor={anchorEl}
        showConfirmButton={false}
        onClose={() => setOpen(false)}
        user={selected}
        onChange={handleUserChange}
      />
    </Box>
  );
};

export default FollowupTypeDropDown;
